<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/apms')">Taquillas</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Estadisticas</a>
  </div>
  <h1 v-if="apmName" class="ui header"><i class="icon chart bar"></i><div class="content">Estadísticas: {{apmName.name}}</div></h1>
  <button class="ui basic button rightButton" v-on:click="goTo('/apms')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div v-if="!apmName" class="ui active centered inline loader"></div>
  <div v-if="apmName" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="getApmStats">
          <h4 class="ui dividing header">Paquetes recogidos entre fechas seleccionadas</h4>
          <div class="fields">
            <div class="field">
              <label>Fecha Inicio</label>
              <datepicker v-model="dateStart" name="dateStart" :language="es"></datepicker>
            </div>
            <div class="field">
              <label>Fecha Final</label>
              <datepicker v-model="dateEnd" name="dateEnd" :language="es"></datepicker>
            </div>
            <div class="field">
              <label> &nbsp;</label>
              <button class="ui button" type="submit">OK</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div  class="row" >
      <div class="column" >
        <b>Total:{{totalak}}</b>
        <chartjs-line :fill="true" :datalabel="mylabel" :labels="mylabels" :data="mydata" :bordercolor="'#00f9a9'" :backgroundcolor="'rgba(0,249,169,0.1)'"></chartjs-line>
      </div>
    </div>
    <div v-if="ilarak" class="row" >
      <div class="column">
        <vue-good-table
        :lineNumbers="true"
        :columns="zutabeak"
        :rows="ilarak"
        styleClass="vgt-table striped condensed bordered"
        >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'client'">
            <span style="font-weight: bold;color:black">{{props.row.client}}</span>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import {es} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import { hapiickApi } from '@/api/hapiickApi';

export default {
  name: 'Stats',
  props: ['id'],
  data() {
    return {
      es: es,
      dateStart: null,
      dateEnd: null,
      apmName: null,
      totalak: null,
      zutabeak:null,
      ilarak:null,
      mylabels:null,
      mydata:null,
      mylabel:'Recogidas por día',
    }
  },
  components: {
    Datepicker
  },
  created() {
    let today = new Date()
    this.dateStart = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1));
    this.dateEnd = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
    if (this.dateStart != null && this.dateEnd != null) {
      this.getApmStats()
    }
  },
  methods: {
    getApmStats() {
      this.apmName=null
      hapiickApi().post('/v2/apms/stats', {
        admin_id: JSON.parse(localStorage.admin).id,
        apm_id: this.id,
        start: this.dateStart,
        end: this.dateEnd
      })
      .then(request => this.apmInfo(request))
      .catch(() => console.log('error getting apm'))
    },
    apmInfo(req) {
      let row, aux, obj, jsonData;
      this.mydata=[]
      this.mylabels=[]
      this.zutabeak=[]
      this.ilarak=[]
      this.totalak=0
      this.atotalak=[]
      this.apmName = JSON.parse(JSON.stringify(req.data.data.name))
      let datuak = JSON.parse(JSON.stringify(req.data.data.rows))
      //let bezeroko = JSON.parse(JSON.stringify(req.data.data.totalak))
      this.zutabeak.push({'label':'Cliente','field':'client','type': 'string'})
      //console.log(datuak);
      for (row in datuak) {
        aux = datuak[row].tbSal
        //console.log(aux)
        
        if (aux.date == 'total') {
          this.totalak=aux.TotalDia
          this.atotalak=aux
        } else {
          this.mydata.push(aux.TotalDia)
          this.mylabels.push(aux.date)
          this.zutabeak.push({'label':aux.date,'field':aux.date})
        }
      }

      this.zutabeak.push({'label':'Total','field':'total'})

      for (obj in this.atotalak){
        if (`${this.atotalak[obj]}` > 0 && obj != 'TotalDia') {
          jsonData = {}
          jsonData['client'] = obj
          for(row in datuak){
            aux = datuak[row].tbSal
              jsonData[aux.date]=aux[obj]
          }
          this.ilarak.push(jsonData)
        }
      }
    },
    goTo(where) {
      this.$router.push(where)
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Apms/Stats.vue